/**
 * Personal Center — order tab filters (per rl-customer-orders root).
 */
(function () {
  'use strict';

  function initRoot(root) {
    if (!root || root.dataset.rlOrdersBound) return;
    root.dataset.rlOrdersBound = '1';
    var tabs = root.querySelectorAll('.co-tab[data-filter]');
    var orders = root.querySelectorAll('.co-order-card[data-fulfillment]');
    if (!tabs.length) return;

    function applyFilter(filter) {
      orders.forEach(function (el) {
        var status = (el.dataset.fulfillment || '').toLowerCase();
        var show = true;
        if (filter === 'fulfilled') show = status === 'fulfilled';
        else if (filter === 'unfulfilled') show = status !== 'fulfilled';
        el.hidden = !show;
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          t.classList.remove('co-tab--active', 'rl-pc-tab--active');
        });
        tab.classList.add('co-tab--active', 'rl-pc-tab--active');
        applyFilter(tab.getAttribute('data-filter') || 'all');
      });
    });

    var active = root.querySelector('.co-tab--active[data-filter]');
    applyFilter(active ? active.getAttribute('data-filter') : 'all');
  }

  function boot() {
    document.querySelectorAll('[data-orders-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
